import { gql } from '@apollo/client';

const GET_APPRAISAL_BY_SEARCH_TEXT = gql`
  query GetAppraisalsBySearchText($filter: String!, $limit: Int, $offset: Int) {
    searchAppraisals(filter: $filter, limit: $limit, offset: $offset) {
      Id
      Name
      AppraisalOrgUnits {
        MddapOrgUnits {
          Name
        }
      }
    }

    searchAppraisalsCount(filter: $filter)
  }
`;

export default GET_APPRAISAL_BY_SEARCH_TEXT;
